<template>
	<div>
		<div class="projects-filters d-none d-md-block">
			<div class="row">
				<div class="col">
					<div class="chips-container tags-preview">
						<div
							v-for="(tag, i) in projectsTags"
							:key="i"
							class="chip"
							:class="{ active: activeProjectsTags.indexOf(tag) > -1 }"
							@click="toggleProjectsTag(tag, activeProjectsTags)"
						>
							{{ tag }}
						</div>
					</div>
				</div>
				<div class="col-auto">
					<button
						class="btn-primary small reverse-color"
						@click="openProjectsFiltersPopup"
					>
						{{ $t('allСategories') }}
					</button>
				</div>
			</div>

			<div
				class="filters-popup"
				:class="{ active: projectsFiltersPopup }"
				v-click-outside="closeProjectsFiltersPopup"
			>
				<div class="chips-container">
					<div
						v-for="(tag, i) in projectsTags"
						:key="i"
						class="chip dark"
						:class="{ active: projectsPopupFilterTags.indexOf(tag) > -1 }"
						@click="toggleProjectsTag(tag, projectsPopupFilterTags)"
					>
						{{ tag }}
					</div>
				</div>
				<div class="filters-popup__actions">
					<div class="row">
						<div class="col">
							<button
								class="btn-outlined"
								@click="projectsPopupFilterTags = []"
							>
								{{ $t('clear') }}
							</button>
						</div>
						<div class="col-auto">
							<button
								class="btn-primary"
								@click="applyProjectsPopupFilter"
							>
								<span class="gradient"></span> {{ $t('apply') }}
							</button>
						</div>
					</div>
				</div>
				<button
					class="btn-close dark"
					@click="closeProjectsFiltersPopup()"
				></button>
			</div>
		</div>

		<div
			class="projects-filters_mobile d-md-none"
			@click="openProjectsFiltersPopup"
		>
			{{ $t('categories') }}
			<span v-if="activeProjectsTags.length"
				>({{ $t('selected') }} {{ activeProjectsTags.length }})</span
			>
		</div>

		<Popup
			v-model="projectsFiltersPopup"
			:titleMobile="$t('selectCategories')"
			class="filters-popup_mobile d-md-none"
		>
			<div class="checkbox-list d-md-none">
				<Checkbox
					v-for="(tag, i) in projectsTags"
					:key="i"
					:checked="projectsPopupFilterTags.indexOf(tag) > -1"
					@input="toggleProjectsTag(tag, projectsPopupFilterTags)"
				>{{ tag }}</Checkbox>
			</div>
			<template #footerMobile>
				<div class="row">
					<div class="col-6 pr-2">
						<button
							class="btn-outlined text-white"
							@click="projectsPopupFilterTags = []"
						>
							{{ $t('clear') }}
						</button>
					</div>
					<div class="col-6 pl-2">
						<button
							class="btn-primary"
							@click="applyProjectsPopupFilter"
						>
							<span class="gradient"></span> {{ $t('apply') }} ({{
								projectsPopupFilterTags.length
							}})
						</button>
					</div>
				</div>
			</template>
		</Popup>
	</div>
</template>

<script>
import Popup from '@/components/Popup'
import Checkbox from '@/components/form/Checkbox.vue'
import clone from 'lodash-es/clone'
import filter from 'lodash-es/filter'
import forEach from 'lodash-es/forEach'

export default {
	props: {
		value: null,
	},

	components: {
		Popup,
		Checkbox,
	},

	created() {
		this.$emit('input', this.filteredProjects)
	},

	watch: {
		filteredProjects(projects) {
			// Обновляем v-model:
			this.$emit('input', projects)
		},

		'$i18n.locale'(locale) {
			// При изменении языка сбрасываем фильтры тегов:
			this.projectsFiltersPopup = false
			this.activeProjectsTags = []
			this.projectsPopupFilterTags = []
		},
	},

	data() {
		return {
			projectsFiltersPopup: false,
			activeProjectsTags: [],
			projectsPopupFilterTags: [],
		}
	},

	computed: {
		projects() {
			return this.$store.getters['projects/projectsByLocale']
		},

		projectsTags() {
			let tags = []
			forEach(this.projects, (project) => {
				forEach(project.tags, (tag) => {
					if (tags.indexOf(tag) > -1) return
					else tags.push(tag)
				})
			})
			return tags
		},

		filteredProjects() {
			let tags = this.activeProjectsTags
			if (!tags.length) return this.projects
			else
				return filter(this.projects, (project) => {
					if (!project.tags || !project.tags.length) return false
					let found = false
					forEach(project.tags, (tag) => {
						if (tags.indexOf(tag) > -1) {
							found = true
							return false
						}
					})
					return found
				})
		},
	},

	methods: {
		toggleProjectsTag(tag, tags) {
			let tagIndex = tags.indexOf(tag)
			if (tagIndex > -1) tags.splice(tagIndex, 1)
			else tags.push(tag)
		},

		openProjectsFiltersPopup($e) {
			this.projectsPopupFilterTags = clone(this.activeProjectsTags)
			this.projectsFiltersPopup = true
			$e.stopPropagation()
		},

		closeProjectsFiltersPopup() {
			this.projectsFiltersPopup = false
		},

		applyProjectsPopupFilter() {
			this.activeProjectsTags = clone(this.projectsPopupFilterTags)
			this.closeProjectsFiltersPopup()
		},
	},
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables';

.projects-filters {
	margin-bottom: 74px;
	position: relative;
	.btn-primary {
		width: 200px;
	}
	.tags-preview {
		max-height: 108px;
		overflow: hidden;
	}
	.filters-popup {
		position: absolute;
		right: 0;
		top: 0;
		z-index: 5;
		width: 100%;
		background: #ffffff;
		box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.1);
		border-radius: 10px;
		padding: 48px;
		color: #333333;
		transform: scale(0.5) translate(50%, -50%);
		pointer-events: none;
		opacity: 0;
		transition: 0.3s;
		&.active {
			transform: scale(1);
			pointer-events: auto;
			opacity: 1;
		}
		&__actions {
			margin-top: 48px;
			[class^='btn-'] {
				height: 48px;
				font-size: 14px;
			}
			.btn-outlined {
				width: 178px;
			}
			.btn-primary {
				width: 272px;
			}
		}
	}
}

.projects-filters_mobile {
	position: relative;
	border: 0 solid #49a8ff;
	border-width: 0.5px 0;
	padding: 10px 0;
	font-weight: 500;
	font-size: 15px;
	line-height: 20px;
	transition: 0.3s;
	cursor: pointer;
	margin-bottom: 16px;
	color: #ffffff;
	span {
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		user-select: none;
		margin-left: 2px;
	}
	&:hover {
		background-color: rgba(#fff, 0.05);
	}
	&::after {
		content: '\e913';
		font-family: 'globalcode-icons' !important;
		position: absolute;
		font-size: 16px;
		right: 4px;
	}
}

@media (max-width: $lg) {
	.projects-filters {
		.tags-preview {
			max-height: 89px;
		}
		.filters-popup {
			padding: 48px 36px 36px;
		}
	}
}
</style>
